import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Contact() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      toast.success('תודה! נחזור אליכם בקרוב', {
        style: {
          background: '#10b981',
          color: 'white',
          border: 'none'
        }
      });
      (e.target as HTMLFormElement).reset();
    }, 1500);
  };
  return <section id="contact" className="py-32 relative z-20 bg-[#0a0a0f]" data-id="element-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-19">
            <h2 className="text-5xl md:text-7xl font-display font-black text-white mb-6" data-id="element-20">
              בואו נדבר
            </h2>
            <p className="text-xl text-white/60 mb-12" data-id="element-21">
              יש לכם פרויקט מעניין? נשמח לשמוע עליו. השאירו פרטים ונחזור אליכם
              בהקדם.
            </p>

            <div className="space-y-8" data-id="element-22">
              <div className="flex items-center gap-6" data-id="element-23">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-[#22d3ee]" data-id="element-24">
                  <Phone size={20} data-id="element-25" />
                </div>
                <div data-id="element-26">
                  <div className="text-white/50 text-sm mb-1" data-id="element-27">טלפון</div>
                  <div className="text-white font-medium text-lg" dir="ltr" data-id="element-28">
                    03-744-3000
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-6" data-id="element-29">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-[#7c5cfc]" data-id="element-30">
                  <Mail size={20} data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <div className="text-white/50 text-sm mb-1" data-id="element-33">אימייל</div>
                  <div className="text-white font-medium text-lg" data-id="element-34">
                    hello@pixel.studio
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-6" data-id="element-35">
                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-[#ff2d8a]" data-id="element-36">
                  <MapPin size={20} data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <div className="text-white/50 text-sm mb-1" data-id="element-39">כתובת</div>
                  <div className="text-white font-medium text-lg" data-id="element-40">
                    רחוב לינקולן 20, תל אביב
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-41">
            <form onSubmit={handleSubmit} className="space-y-6 bg-white/[0.02] p-8 md:p-10 rounded-3xl border border-white/5" data-id="element-42">
              <div data-id="element-43">
                <label htmlFor="name" className="block text-sm font-medium text-white/70 mb-2" data-id="element-44">
                  שם מלא
                </label>
                <input type="text" id="name" required className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-4 text-white focus:outline-none focus:border-[#7c5cfc] transition-colors" placeholder="ישראל ישראלי" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <label htmlFor="email" className="block text-sm font-medium text-white/70 mb-2" data-id="element-47">
                  אימייל
                </label>
                <input type="email" id="email" required className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-4 text-white focus:outline-none focus:border-[#7c5cfc] transition-colors" placeholder="israel@example.com" dir="ltr" data-id="element-48" />
              </div>
              <div data-id="element-49">
                <label htmlFor="message" className="block text-sm font-medium text-white/70 mb-2" data-id="element-50">
                  הודעה
                </label>
                <textarea id="message" required rows={4} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-4 text-white focus:outline-none focus:border-[#7c5cfc] transition-colors resize-none" placeholder="ספרו לנו על הפרויקט שלכם..." data-id="element-51" />
              </div>
              <button type="submit" disabled={isSubmitting} className="w-full py-4 bg-gradient-to-r from-[#7c5cfc] to-[#22d3ee] text-white font-bold rounded-xl hover:opacity-90 transition-opacity disabled:opacity-50" data-id="element-52">
                {isSubmitting ? 'שולח...' : 'שליחה'}
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}